export const modals = {
    SIGN_UP_MODAL: 'SIGN_UP_MODAL',
    SIGN_UP_AGREEMENT_MODAL: 'SIGN_UP_AGREEMENT_MODAL',
    SIGN_UP_ACTIVATION_CODE_MODAL: 'SIGN_UP_ACTIVATION_CODE_MODAL',
    SIGN_UP_ALL_SET_MODAL:'SIGN_UP_ALL_SET_MODAL',
    SIGN_UP_AUTHENTICATED_MODAL:'SIGN_UP_AUTHENTICATED_MODAL',
    MARGINAL_TAX_RATE_MODAL: 'MARGINAL_TAX_RATE_MODAL',
    E_DELIVERY_AGREEMENT_MODAL:'E_DELIVERY_AGREEMENT_MODAL',
    DAILY_PRICES_INVESTMENT_OPTIONS_MODAL: 'DAILY_PRICES_INVESTMENT_OPTIONS_MODAL',
    MONTHLY_PERFORMANCE_INVESTMENT_OPTIONS_MODAL: 'MONTHLY_PERFORMANCE_INVESTMENT_OPTIONS_MODAL',
    SAVED_MODAL: 'SAVED_MODAL',
    CONFIRM_SAVE_MODAL: 'CONFIRM_SAVE_MODAL'
};